import { render, staticRenderFns } from "./PermisosComponent.vue?vue&type=template&id=7e2ce8ac&"
import script from "./PermisosComponent.vue?vue&type=script&lang=js&"
export * from "./PermisosComponent.vue?vue&type=script&lang=js&"
import style0 from "./PermisosComponent.vue?vue&type=style&index=0&id=7e2ce8ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports